// Klicks in der Trefferliste der Suchergebnisseite erfassen.
//
// Die Liste rendert Ceres (bzw. das Theme) serverseitig - es gibt keine
// eigene Komponente, in die sich ein @click haengen liesse. Deshalb ein
// einziger delegierter Listener am Dokument.
//
// Markup (bigtex, 17.09.2026):
//   ul.product-list > li > article.cmp-product-thumb[data-testing=<Variations-ID>]
//
// ARTIKEL AUS DEM LINK, NICHT AUS DER KACHEL: Die Farbpunkte einer Kachel
// fuehren zu ANDEREN Artikeln (/slug/a-21345/). Wer dort klickt, landet auf
// diesem Artikel und kauft ihn womoeglich - der Klick gehoert also ihm.
// Nur wenn der Link keinen Artikel verraet, zaehlt die Variante der Kachel.

import { api, cfg } from './api'

// alt: /slug/a-{itemId}/   neu: /slug_{itemId} oder /slug_{itemId}_{variationId}
function artikelAusLink (href) {
  if (!href) return {}
  let pfad
  try {
    pfad = new URL(href, window.location.origin).pathname
  } catch (e) {
    return {}
  }
  const alt = pfad.match(/\/a-(\d+)\/?$/)
  if (alt) return { item_id: Number(alt[1]) }
  const neu = pfad.match(/_(\d+)(?:_(\d+))?\/?$/)
  if (neu) {
    return neu[2]
      ? { item_id: Number(neu[1]), variation_id: Number(neu[2]) }
      : { item_id: Number(neu[1]) }
  }
  return {}
}

// Position ueber Seiten hinweg. Artikel je Seite: aus der URL (?items=),
// sonst die Zahl der Kacheln auf dieser Seite. Auf der letzten Seite einer
// Suche mit weniger Kacheln waere das zu klein - ohne items-Parameter bleibt
// die Position dort ungenau. Seite 1 stimmt immer.
function position (li) {
  const liste = li.parentElement
  if (!liste) return undefined
  const kacheln = Array.prototype.filter.call(liste.children, function (el) { return el.tagName === 'LI' })
  const index = kacheln.indexOf(li)
  if (index < 0) return undefined

  const sp = new URLSearchParams(window.location.search)
  const seite = Math.max(1, parseInt(sp.get('page'), 10) || 1)
  const jeSeite = parseInt(sp.get('items'), 10) || kacheln.length

  return (seite - 1) * jeSeite + index + 1
}

function suchbegriff () {
  const sp = new URLSearchParams(window.location.search)
  return (sp.get('query') || sp.get('q') || '').trim()
}

export function registerResultClickTracking () {
  if (typeof document === 'undefined' || !cfg().isSearchPage) return

  document.addEventListener('click', function (e) {
    try {
      const link = e.target && e.target.closest && e.target.closest('a[href]')
      if (!link) return

      const kachel = link.closest('article.cmp-product-thumb')
      const li = kachel && kachel.closest('ul.product-list > li')
      if (!li) return

      const q = suchbegriff()
      if (!q) return

      const artikel = artikelAusLink(link.getAttribute('href'))
      if (!artikel.item_id) {
        const variante = parseInt(kachel.getAttribute('data-testing'), 10)
        if (!variante) return
        artikel.variation_id = variante
      }

      api.trackClick({ q, type: 'result', position: position(li), ...artikel })
    } catch (err) {
      // Tracking darf den Klick nie aufhalten.
    }
  }, true)
}
